import { t } from "@lingui/macro";
import { useFragment } from "react-relay";

import { Avatar } from "@whoosh/design-system/src/components/display/Avatar";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { EventDetailHostsFragment } from "./EventDetailHosts";
import { EventDetailHosts$key } from "./__generated__/EventDetailHosts.graphql";

type EventDetailHostsRedesignProps = {
  fragmentRef: EventDetailHosts$key | null;
};

export const EventDetailHostsRedesign = ({
  fragmentRef,
}: EventDetailHostsRedesignProps) => {
  const data = useFragment(EventDetailHostsFragment, fragmentRef);

  if (data == null || data.event?.hostsVisible === false) {
    return null;
  }

  const hosts = data?.event?.hosts?.edges;

  if (!hosts?.length) {
    return null;
  }

  return (
    <VStack width="100%" gap={2}>
      <Box height={24} justifyContent="center">
        <Text
          variant="mainSmallSemiBold"
          color="text-secondary"
        >{t`Hosted by`}</Text>
      </Box>
      <HStack gap={4} flexWrap="wrap" alignItems="center">
        {hosts.map((hostEdge) => {
          const host = hostEdge?.node;
          if (!host) return null;

          return (
            <HStack
              key={`host-${host.id}`}
              gap={4}
              alignItems="center"
              flex={1}
            >
              <Avatar
                profileImagePublicId={host.profileImage?.publicId}
                firstName={host.user?.firstName || ""}
                lastName={host.user?.lastName || ""}
                size="sm"
                type={data.event?.eventSeries?.color ?? "member"}
              />
              <Text variant="mainBaseMedium" color="text-primary">
                {host.user?.fullName || ""}
              </Text>
            </HStack>
          );
        })}
      </HStack>
    </VStack>
  );
};
